<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto flex max-w-screen-xl flex-col">
      <div class="flex flex-col items-center justify-between space-y-10 lg:block">
        <div class="text-center text-2xl font-bold lg:text-3xl">
          {{ title }}
        </div>
        <div v-if="buttons && buttons.length" class="flex w-full items-center justify-center space-x-6">
          <VcButton
            v-for="(item, index) in buttons"
            :key="index"
            v-bind="getLinkAttr(item.link)"
            class="w-1/2 px-8 lg:w-auto"
          >
            {{ item.label }}
          </VcButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getLinkAttr } from "@/core/utilities/common";

type ButtonType = {
  label: string;
  link: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
  title?: string;
  buttons?: Array<ButtonType>;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)]",
    props.bottomMargin ? props.bottomMargin : "my-0",
    props.verticalPadding ? props.verticalPadding : "py-10 lg:py-20",
  ];
});
</script>

<style lang="scss">
.call-to-action-block {
  &.bg-neutral-800 .text-50 {
    color: white;
  }
}
</style>
